import { render } from "./QuoteSchemajson.vue?vue&type=template&id=2c5693e0"
import script from "./QuoteSchemajson.vue?vue&type=script&lang=js"
export * from "./QuoteSchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__